<template>
  <div class="com-chart-title" :style="style">{{ props.title }}</div>
</template>
<script setup>
  const props = defineProps(['title', 'style'])
</script>
<style lang="scss" scoped>
</style>